import React from "react";
import { Autocomplete, Chip, Grid, MenuItem, Stack, TextField } from "@mui/material";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ShareIcon from '@mui/icons-material/Share';
import InboxIcon from '@mui/icons-material/Inbox';
import { addContainer, getContainers } from "src/services/container.service";
import containerMethods from "src/methods/container.methods";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


export default class ContainersAutocomplete extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            containers: props?.containers ? props.containers : [],
            container_suggestions: []
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.containers !== this.props.containers) {
            this.setState({
                containers: this.props.containers
            });
        }
    }

    updateContainerSuggestions = async (params=null) => {
		try {

			let query = {
				limit: 10,
				skip: 0
			};

			let search;
			if (params) {
				search = params.target.value;
				query.search = search;
			}

			let containers = await getContainers(query);
			
			if (containers.error) {
				console.log("Error fetching containers:", containers.error);
				this.setState({
					container_suggestions: []
				});
				return;
			}

			containers = containers.containers;

			let container_suggestions = containers.map(container => {
				return {
					id: container._id,
					label: container.name,
                    name: container.name,
					type: container.type,
					color: container.color,
					is_owner: container.is_owner,
                    is_shared_outside_company: container.is_shared_outside_company,
                    owner: container.owner,
                    automatically_created: container.automatically_created
				}
			});

			if (search) {
				container_suggestions.push({
					id: search,
					label: `Create Group "${search}"`,
					type: 'container',
					is_owner: true,
                    is_shared_outside_company: false,
					create: true,
                    automatically_created: false
				});
			}

			this.setState({
				container_suggestions: container_suggestions
			});

		} catch (error) {
			console.error("Error fetching container suggestions:", error);
		}
	}

    createContainer = async (container_name, type='container') => {
		let createdContainer = await addContainer({
			name: container_name,
			type: type
		})
		if (createdContainer.error) {
			return null;
		}
		return createdContainer.container;
	}

    render() {
        return (
            <Autocomplete
                disabled={this.props.disabled}
                freeSolo
                multiple
                id="containers-outlined"
                options={this.state.container_suggestions}
                value={this.state.containers}
                onChange={async (event, newValue) => {


                    // Create new container
                    
                    let updatedContainers = [];
                    for (let i = 0; i < newValue.length; i++) {
                        if (newValue[i].create) {
                            let created_container = await this.createContainer(newValue[i].id, 'container');
                            if (!created_container) {
                                
                            } else {
                                updatedContainers.push({
                                    id: created_container._id,
                                    label: created_container.name,
                                    name: created_container.name,
                                    type: created_container.type,
                                    color: created_container.color,
                                    is_owner: created_container.is_owner,
                                    is_shared_outside_company: created_container.is_shared_outside_company,
                                    automatically_created: created_container.automatically_created
                                });
                            }
                        } else if (typeof newValue[i] === 'string') {
                            let created_container = await this.createContainer(newValue[i], 'container');
                            if (!created_container) {

                            } else {
                                updatedContainers.push({
                                    id: created_container._id,
                                    label: created_container.name,
                                    name: created_container.name,
                                    type: created_container.type,
                                    color: created_container.color,
                                    is_owner: created_container.is_owner,
                                    is_shared_outside_company: created_container.is_shared_outside_company,
                                    automatically_created: created_container.automatically_created
                                });
                            }
                        } else {
                            updatedContainers.push(newValue[i]);
                        }
                    }


                    this.setState({
                        containers: updatedContainers
                    });

                    if (this.props.onChange) {
                        this.props.onChange(updatedContainers);
                    }
                }}
                onFocus={() => {
                    this.updateContainerSuggestions();
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label={this.props.label || "Departments / Teams / Projects / Groups"}
                        placeholder={this.props.placeholder || "Department, Team, Project, or Group"}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                    <InboxIcon />
                                </React.Fragment>
                            )
                        }}
                        onChange={this.updateContainerSuggestions}
                    />
                )}
                renderOption={(props, option, { active }) => (
                    <MenuItem {...props}
                        sx={{
                            backgroundColor: active
                                ? 'action.hover' // MUI's default hover color
                                : option.color || 'inherit',
                            transition: 'background-color 0.2s',
                        }}
                    >
                        <Grid container alignItems="center" spacing={1} justifyContent={'space-between'} textAlign={'center'}>
                            <Grid item display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                {containerMethods.getContainerIcon()}
                                <span style={{marginLeft: '5px', fontWeight: 'bold'}}></span>
                                {option.label}
                                {/* If not owner, then show owner name also */}
                                {(!option.is_owner) ? (
                                    <span style={{marginLeft: '5px', fontSize: '0.8em', color: 'gray'}}>
                                        {`(Shared by ${option?.owner?.name || option?.owner?.email || ''})`}
                                    </span>
                                ) : null}
                            </Grid>
                            <Stack direction="row" spacing={1}>
                                {(option.automatically_created) ? (<AutoAwesomeIcon fontSize="small" color="action" />) : null}
                                {(option.is_shared_outside_company) ? (<ShareIcon fontSize="small" color="action" />) : null}
                                {(option.is_owner) ? (<AdminPanelSettingsIcon fontSize="small" color="action" />) : (<PeopleAltIcon fontSize="small" color="action" />)}
                            </Stack>
                        </Grid>
                    </MenuItem>
                )}
                renderTags={(value, getTagProps) => (
                    <>
                        {value.map((option, index) => (
                            <Chip
                                key={index}
                                variant="outlined"
                                avatar={containerMethods.getContainerIcon()}
                                label={option.label}
                                sx={{borderRadius: 1, margin: 1, backgroundColor: option.color || 'white'}}
                                {...getTagProps({ index })}
                            />
                        ))}
                    </>
                )}
                sx={{ width: '100%' }}
                size="small"
                selectOnFocus
            />
        );
    }
}